import clsx from "clsx";
import Link from "next/link";
import React, { FC } from "react";

interface PostTagProps {
  value: string;
  label: string;
  index: number;
}

const colorMap = {
  "0": "bg-gradient-a",
  "1": "bg-gradient-b",
  "2": "bg-gradient-c",
  "3": "bg-gradient-d",
  "4": "bg-gradient-e",
};

export const PostTag: FC<PostTagProps> = (props) => {
  const { value, label, index } = props;

  if (!value || !label) return null;

  const bgClassName = colorMap[getColorKey(index)];

  return (
    <Link href={`/tag/${value}`}>
      <a>
        <div
          className={clsx("p-px rounded-3xl", bgClassName)}
          data-test-id="PostTag-container"
        >
          <span className="py-1 px-4 flex w-full h-full justify-center items-center rounded-3xl bg-white">
            <span
              className={clsx(
                "text-transparent bg-clip-text text-sm  whitespace-nowrap",
                bgClassName,
              )}
            >
              {label}
            </span>
          </span>
        </div>
      </a>
    </Link>
  );
};

const getColorKey = (index: number) => {
  if (index < 5) return index.toString();
  return (index % 5).toString();
};
